// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__1YDF6","inputText":"TextInput_inputText__3X9HB","error":"TextInput_error__1Ta05"};